import { Component, Input, OnInit } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';
import { FeedbackService, MsgType } from '../../../../_provider/feedback.service';
import dayjs from '../../../../_utils/dayjs.config';
import { ZeitenService } from '../../../../_provider/zeiten.service';
import { HttpFunctionResult } from '../../../../_interfaces/HttpFunctionResult';
import { TicketEmployee } from '../../../../_provider/tickets/ticket.service';
import { DarkmodeService } from '../../../../_provider/darkmode.service';
import { TicketZeit } from '../../../../_interfaces/TicketTime';
import { EditArt } from 'src/app/_interfaces/EditArt';
import { PopoverPage } from 'src/app/_template/popover/popover.page';
import { Task } from 'src/app/_interfaces/Task';

@Component({
  selector: 'app-add-time',
  templateUrl: './add-time.page.html',
  styleUrls: ['./add-time.page.scss'],
})
export class AddTimePage implements OnInit {

  public now: string = new Date().toISOString()

  public date: string = new Date().toISOString()
  public von: string = new Date().toISOString()
  public bis: string = dayjs(new Date).add(30, "minutes").toISOString()
  private workstepId: number
  public note: string = ""
  public editMode: boolean = false
  private timeId: number = 0
  public type: "correct24Time" | "editOrAddTime" = "editOrAddTime" 
  private taskId: number 
  private customTasks: Task[] = []

  public activeTask: EditArt = {id: 0, description: "Ticketzeiten"}

  constructor(
    private modalCtrl: ModalController,
    private feedback: FeedbackService,
    private navParams: NavParams,
    public darkmode: DarkmodeService,
    private ticketSrv: TicketEmployee.TicketService,
    private timeSrv: ZeitenService
  ) {
    const ticketTime: TicketZeit = this.navParams.data.ticketTime
    this.type = this.navParams.data?.type || "editOrAddTime"
    if(!ticketTime) return
    this.editMode = true
    this.workstepId = ticketTime?.workstepId || 0
    this.timeId = ticketTime.id
    this.date = new Date(ticketTime.timeFrom).toISOString()
    this.von = new Date(ticketTime.timeFrom).toISOString()
    this.bis = this.type == "editOrAddTime" ? new Date(ticketTime.timeTo).toISOString() : dayjs(this.von).add(1, "hours").toISOString()
    this.note = ticketTime.note
    this.taskId = ticketTime.taskId
  }
  
  async ngOnInit() {

    //Wenn das Speichern von Zeit über 24 Stunden dann eigene Tätigkeiten setzen
    //sonst die Tätigkeiten nehmen von aktuell ausgewählten arbeitsschritt
    if(this.type == "correct24Time"){
      this.customTasks = await this.ticketSrv.setTasks(this.workstepId, false);
      this.customTasks.unshift({id: 0, description: "Ticketzeiten"})
      const task: Task = this.customTasks.find(t => t.id == this.taskId)
      if(task) this.activeTask = {id: task.id, description: task.description}
    }
    else{
      const task: Task = this.ticketSrv.tasks.find(t => t.id == this.taskId)
      if(task) this.activeTask = {id: task.id, description: task.description}
    }
    
  }

  public async save(){
    const from: dayjs.Dayjs = dayjs(this.von)
    const to: dayjs.Dayjs = dayjs(this.bis)
    
    if(!dayjs(this.date).isValid()) return await this.feedback.showError("Bitte geben Sie in gültiges Datum an und versuchen Sie es erneut.")

    const tt: TicketZeit = {
      timeFrom: dayjs(this.date)
      .set("hours", from.get("hours"))
      .set("minutes", from.get("minutes"))
      .set("seconds", this.editMode ? from.get("seconds") : 0)
      .toDate(),
      timeTo: dayjs(this.date)
      .set("hours", to.get("hours"))
      .set("minutes", to.get("minutes"))
      .set("seconds", this.editMode ? to.get("seconds") : 0)
      .toDate(),
      date: dayjs(this.date).toDate(),
      note: this.note,
      taskId: this.activeTask.id
    }
    
    if(tt.timeTo <= tt.timeFrom) return await this.feedback.showError( 'Die Zeit für "Bis" muss höher sein als "Von".')
    await this.feedback.hideKeyboardOnIOS()
    await this.modalCtrl.dismiss(tt)
    
  }


  public async deleteTime(){
    if(!(await this.feedback.confirm("Möchten Sie die Ticketzeit wirklich löschen?", "Löschen", "Abbrechen"))) return
    if(this.type == "correct24Time"){
      await this.modalCtrl.dismiss()
      return
    }
    await this.feedback.updateLoading("Löschen...")
    this.timeSrv.deleteTime(this.timeId, async (result: HttpFunctionResult<any>)=>{
      await this.feedback.hideLoading()
      if(!result.success) await this.feedback.showMsg(MsgType.Error, result.message)
      else{
        await this.ticketSrv.setTimes(this.ticketSrv.activeWorkstepId)
        await this.feedback.hideKeyboardOnIOS()
        await this.modalCtrl.dismiss()
      }
    })
  }

  public async close(){
    await this.feedback.hideKeyboardOnIOS()
    await this.modalCtrl.dismiss()
  }

  public setFromOrTo(event: string, type: "from" | "to"){
    const splittet = event.split(":")
    const hours: number = +splittet[0]
    const minutes: number = +splittet[1]

    const newIsoString: string = dayjs(new Date())
    .set("hours", hours)
    .set("minutes", minutes)
    .toISOString()

    if(type == "from") this.von = newIsoString
    else this.bis = newIsoString

  }

  public async selectTask(event: Event){    
    this.feedback.openPopover<EditArt>(PopoverPage, event, {type: this.type == "editOrAddTime" ? "timeArt" : "custom", list: this.type == "correct24Time" ? this.customTasks : []}, (result: HttpFunctionResult<EditArt>)=>{
      if(!result.success) return
      this.activeTask = result.data
    })
  }



}
